export class UnauthorizedError extends Error {
  code = 401;

  constructor() {
    super();
  }
}
